import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../_services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CommunitiesService} from "../_services/communities.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Community} from "../_types/communities";

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrl: './password-reset.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordResetComponent {
    loading: boolean = false;
    showpassword: boolean = false;
    showConfirmPassword: boolean = false;
    passwordForm: FormGroup;
    token: string = '';
    companyImg: string = localStorage.getItem('communityLogo') || 'assets/explainLogoPlaceholder.png';
    companyName: string = localStorage.getItem('communityName') || 'Explain';
    community: Community | null = null;

    constructor(private readonly formBuilder: FormBuilder,
                private authService: AuthService,
                private readonly communitiesService: CommunitiesService,
                private route: ActivatedRoute,
                private readonly router: Router,
                private readonly snackBar: MatSnackBar) {
        this.route.params
            .subscribe(params => {
                this.token = params['token'];
            }, error => {
                this.openSnackBar(error, 'error')
                console.error(error);
            });
        this.passwordForm = this.formBuilder.group({
            password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
        })
        this.communitiesService.getCurrentDashboardCommunity()
            .pipe(takeUntilDestroyed())
            .subscribe(community => {
                this.community = community;
                if (community) {
                    this.companyImg = community.logo || 'assets/explainLogoPlaceholder.png';
                    this.companyName = community.name || 'Explain';
                }
            });
    }

    resetPassword(): void {
        this.loading = true;
        let body = {
            new_password: this.passwordForm.value.password,
            confirm_password: this.passwordForm.value.confirmPassword
        }
        this.authService.resetPassword(this.token, body).subscribe(r => {
            this.loading = false;
            this.openSnackBar('Password reset successful', 'success')
            this.router.navigate(['/login']);
        }, e => {
            this.loading = false;
            this.openSnackBar(e, 'error')
        })

    }

    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }
}
